/**
 * THE SYNTHETIC SYMBOL that opens the custom-data upload.
 *
 * <h2>It exists only in the browser</h2>
 *
 * The backend has never heard of this string, deliberately. A run on client-supplied data is
 * selected by the PRESENCE OF A PAYLOAD on a POST, not by a reserved ticker name — so there is one
 * decision in one place rather than a comparison in every layer that handles a symbol. That matters
 * because this codebase has been bitten three times by a magic value one call site forgot to check,
 * and a sentinel ticker is exactly that pattern: `StorageBarSource` would look for
 * `eod/Z-CUSTOM.txt`, the activity filter would record it as a ticker search, and each would need
 * its own guard.
 *
 * <p>So this entry is an affordance. Selecting it opens the upload; everything after that is driven
 * by whether a series has been parsed. A caller who posts a payload under the name `SPY` gets their
 * own data, and a caller who selects this entry without uploading anything gets no run at all.
 *
 * <p>It is also why the backend labels every custom run `CUSTOM_EPHEMERAL` and discards whatever
 * name was sent: the label a customer sees here and the token written to a log are separate
 * concerns, and only one of them should be able to carry a customer's choice of words.
 */
export const CUSTOM_SYMBOL = 'Z-Custom';

/** Whether a selected symbol is the synthetic upload entry rather than a real ticker. */
export const isCustomSymbol = (symbol) =>
  typeof symbol === 'string' && symbol.trim().toUpperCase() === CUSTOM_SYMBOL.toUpperCase();

export default CUSTOM_SYMBOL;
